/**
 * Visible DEMO badge. Rendered whenever the app runs in DEMO mode (no
 * VITE_API_BASE_URL configured). DEMO is scoped strictly to that case.
 */

import { Chip } from "@mui/material";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import { IS_DEMO } from "../api/client";

export function DemoBadge() {
  if (!IS_DEMO) return null;
  return (
    <Chip
      icon={<ScienceOutlinedIcon />}
      label="DEMO · datos de demostración"
      color="warning"
      variant="outlined"
      size="small"
      sx={{ fontWeight: 600 }}
    />
  );
}
